<project-navigation
  [headerTitle]="headerTitle"
  [headerText]="headerText"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [whySubmitDisabled]="'projectNavigation.text_save_configuration_validation_error'"
  [actionButtonLabel]="'global.label.save'"
  [visibleFeatures]="{
    compositeCheckBox: visibleCompositeCheckBox,
    pinnedProjects: true,
    recentlyUsedProjects: true,
    history: true,
    projectActionsMenu: true,
    projectGroupContextMenu: true,
    newConfigurationGroupBtn: true,
    newFolderBtn: true,
    dialogSearch: true,
    tabs: true,
    breadcrumbs: true,
  }"
  [compositeCheckBoxLabel]="'save.label.save_as_composite'"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="saveSelectedProject()"
  (cancel)="cancel()"
></project-navigation>
